import { Component } from '@angular/core';
import { InfoComponent } from "../home/info/info.component";
import {
  ExamPrePostHeroComponent
} from "../examenes-pre-post-ocupacional/exam-pre-post-hero/exam-pre-post-hero.component";
import {HeroFeriasCharlasSaludComponent} from "./hero-ferias-charlas-salud/hero-ferias-charlas-salud.component";
import {ImportantItemsFeriasComponent} from "./important-items-ferias/important-items-ferias.component";
import {FooterPersonaComponent} from "../../app-persona/footer-persona/footer-persona.component";



@Component({
  selector: 'app-ferias-charlas-salud',
  standalone: true,
    imports: [ExamPrePostHeroComponent, InfoComponent, HeroFeriasCharlasSaludComponent, ImportantItemsFeriasComponent, FooterPersonaComponent],
  templateUrl: './ferias.charlas-salud.component.html',
  styleUrl: './ferias-charlas-salud.component.css'
})
export class FeriasCharlasSaludComponent {

  name="Ferias y Charlas de Salud";
  description = "Participación en eventos, ferias, charlas, etc. donde se abordan temas de bienestar fisico, mental y nutricional, orientados a mejorar la salud de los empleador.";
  description2 = "";
  routeLogo = "assets/img/enterprise/preventivas.svg";
  routeImage = "assets/img/enterprise/bannerEmpresarial.svg"

}
